module.exports = __webpack_public_path__ + "static/media/empty-file.7dec8739.svg";